import { createFileRoute } from '@tanstack/react-router';

import { BoqListPage } from '@/features/cost/boq-list-page';

export const Route = createFileRoute('/_app/projects/$projectId/cost/boq/')({
  component: BoqListRoute,
});

function BoqListRoute() {
  const { projectId } = Route.useParams();
  return <BoqListPage projectId={projectId} />;
}
